export default {
  save: 'Save',
} as const;
